import React, { useEffect, useMemo, useState } from "react";
import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { rankItem } from "@tanstack/match-sorter-utils";
import { InputGroup, Form, Tab, Button, Modal } from "react-bootstrap";
import { useDataFetch } from "./../../hooks/useDataFetch";
import AdminsCreate from "../components/Admin/Create";

const fuzzyFilter = (row, columnId, value) => {
  return rankItem(row.getValue(columnId), value).passed;
};

const GlobalFilter = ({ globalFilter, setGlobalFilter }) => {
  return (
    <InputGroup className="mb-3">
      <Form.Control
        placeholder="Buscar"
        value={globalFilter ?? ""}
        onChange={(e) => setGlobalFilter(e.target.value || undefined)}
      />
    </InputGroup>
  );
};

const Admins = () => {
  const [globalFilter, setGlobalFilter] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [newAdmin, setNewAdmin] = useState(false);

  const { getData, invalidateQuery } = useDataFetch();

  const { status, data, error, isFetching, refetch } = getData(
    ["users"],
    "/users",
    { enabled: true }
  );

  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        id: "name",
        header: "Nombre",
      },
      {
        accessorKey: "email",
        id: "email",
        header: "Correo",
      },
    ],
    []
  );

  const table = useReactTable({
    data: data?.data ?? [],
    columns,
    state: {
      globalFilter,
      pagination,
    },
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: fuzzyFilter, // Aplicar filtro fuzzy para el filtro global
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onPaginationChange: setPagination,
  });

  return (
    <Tab.Container defaultActiveKey="all">
      <div className="d-flex justify-content-end">
        <div className="d-flex" style={{ width: 500 }}>
          <GlobalFilter
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
          />
          <Button
            className="btn btn-primary text-nowrap mb-3 ml-3"
            onClick={() => setNewAdmin(true)}
          >
            <i className="fa fa-plus scale5 mr-3" aria-hidden="true" />
            Nuevo
          </Button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table card-table display dataTablesCard dataTable no-footer">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id}>
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
          <div className="dataTables_info">
            Showing{" "}
            {table.getRowModel().rows.length *
              (table.getState().pagination.pageIndex + 1)}{" "}
            of {table.getRowCount().toLocaleString()} Rows
          </div>
          <div
            className="dataTables_paginate paging_simple_numbers"
            id="example2_paginate"
          >
            <Button
              className="paginate_button previous"
              onClick={() => table.previousPage()}
              disabled={!table.getCanPreviousPage()}
            >
              Previous
            </Button>

            <Button
              className="paginate_button next"
              onClick={() => table.nextPage()}
              disabled={!table.getCanNextPage()}
            >
              Next
            </Button>
          </div>
        </div>
      </div>
      <Modal className="fade bd-example-modal-lg" show={newAdmin} size="xl">
        <Modal.Header>
          <Modal.Title>Nuevo Administrador</Modal.Title>
          <Button
            variant=""
            className="close"
            onClick={() => setNewAdmin(false)}
          >
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <AdminsCreate
            refetchStudent={() => {
              invalidateQuery("users");
              refetch();
            }}
          />
        </Modal.Body>
      </Modal>
    </Tab.Container>
  );
};

export default Admins;
